module.exports = __webpack_public_path__ + "assets/9526ee2409350c4296481f2090f00645.mp3";